/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled, { css } from "styled-components";
import Popover from "components/shared/Popover";
import { useLocalizedGuidePage } from "hooks/useLocalizedGuidePage";
import { LocaleLink } from "utilities/NavigationUtilities";

const CommunityLinkContainer = styled.div`
  padding: 14px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

const CommunityLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 146px;
`;

const CommunityLink = styled(LocaleLink)`
  text-decoration: none;
  color: var(--spectrum-gray-800);
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
`;

const AFFILIATES_SLUG_EN = "adobe-podcast-affiliate-program";
const EVENTS_SLUG_EN = "adobe-podcast-events";

export const CommunityLinks: React.FC<{ mobile?: boolean }> = ({ mobile }) => {
  const affiliatePath = useLocalizedGuidePage(AFFILIATES_SLUG_EN);
  const eventsPath = useLocalizedGuidePage(EVENTS_SLUG_EN); //'Events' removed for now
  const buttonContent = (
    <>
      <sp-icon-chevron-down slot="icon" />
      <span style={{ fontSize: mobile ? 18 : 16 }}>
        {I18n.t("links.community.title")}
      </span>
    </>
  );

  const button = mobile ? (
    <sp-button dir="rtl" size="xl" variant="secondary" style={{ fontSize: 18 }}>
      {buttonContent}
    </sp-button>
  ) : (
    <sp-action-button quiet dir="rtl" size="m">
      {buttonContent}
    </sp-action-button>
  );

  return (
    <overlay-trigger placement="bottom-start">
      <div slot="trigger">{button}</div>
      <Popover>
        <CommunityLinksContainer>
          <CommunityLink to={affiliatePath}>
            <CommunityLinkContainer>
              {I18n.t("links.community.affiliates")}
            </CommunityLinkContainer>
          </CommunityLink>
          {/* <CommunityLink to={eventsPath}> */}
          {/*   <CommunityLinkContainer> */}
          {/*     {I18n.t("links.community.events")} */}
          {/*   </CommunityLinkContainer> */}
          {/* </CommunityLink> */}
          <CommunityLink to="https://community.adobe.com/t5/adobe-podcast/ct-p/ct-adobe-podcast?page=1&sort=views&lang=all&tabid=all">
            <CommunityLinkContainer>
              {I18n.t("links.community.forums")}
            </CommunityLinkContainer>
          </CommunityLink>
        </CommunityLinksContainer>
      </Popover>
    </overlay-trigger>
  );
};
